module.exports = __webpack_public_path__ + "static/media/devices.2c93775e.svg";